import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { orderingTabs } from '../../../routes/sales';

const SalesSideOrdering = () => {
  const tabs = orderingTabs();
  return <FingoPaper tabs={tabs} />;
};

export default SalesSideOrdering;
